<template>
  <button type="button" class="btn btn-unstyled expand-button"
    role="button"
    tabindex="0"
    @click="onClick">
    <div class="expand-icon" :class="{ expanded: props.expanded, hidden: props.hidden }">
    </div>
  </button>
</template>

<style lang="scss" scoped>
.expand-button {
  width: 16px;
  height: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-icon {
  height: 10px;
  width: 10px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform-origin: 75% 25%;
  transform: translateY(25%) scale(0.7) rotate(45deg);
  transition: transform 0.2s;

  &.expanded {
    transform: translateY(25%) scale(0.7) rotate(135deg);
  }

  &.hidden {
    opacity: 0;
  }
}
</style>

<script lang="ts" setup>
const props = defineProps<{
  hidden?: boolean
  expanded?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:expanded', value: boolean): void
}>()

function onClick() {
  emit('update:expanded', !props.expanded)
}
</script>
